import { Injectable } from '@angular/core';

import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

const APPLE_PATTERN = /(mac|iphone|ipod|ipad)/i;
const EVENT_PATTERN = /^click(\.(normal|shift|alt|ctrl)){1,3}$/;

@Injectable()
export class ClickModifiersPlugin {
	addEventListener(
		target: HTMLElement,
		eventName: string,
		originalHandler: any,
	): Function {
		// Extrait les modifiers demande pour l'event handler
		let modifiers = eventName.split(".").slice(1);
		
		// Convertit les modifiers en clefs portees par les evenements de type MouseEvent
		let keys = modifiers.map(
			mod => {
				if (mod === 'normal') {
					return 'normal';
				}
				
				if (mod === 'ctrl') {
					// NB: la touche ctrl chez apple porte un autre nom
					let isApple = APPLE_PATTERN.test(navigator.platform);
					return isApple ? 'metaKey' : 'ctrlKey';
				}
				
				return mod + 'Key';
			}
		);

		const subscription = fromEvent(target, 'click').pipe(
			filter((e : any) => {
				if (modifiers.length === 1 && modifiers[0] === 'normal') {
					// Cas special: on veut explicitement un click sans aucune touche pressee
					let allKeys = ['ctrlKey', 'metaKey', 'shiftKey', 'altKey'];
					let hasNoModifiers = allKeys.every(modifier => !e[modifier]);
					return hasNoModifiers;
				}
				
				let hasAllRequestedKeys = keys.every(modifier => e[modifier]);
				return hasAllRequestedKeys;	
			})
		).subscribe(originalHandler);

		return () => subscription.unsubscribe();
	}

	supports(eventName: string): boolean {
		return EVENT_PATTERN.test(eventName);
	}
}
